import React from "react";
import { CopyrightCashParking } from "../cashparking/CopyrightCashParking";
import { PrivacyPolicy } from "../commonComponents/PrivacyPolicy";
import classes from "./YahooLayout.module.scss";

export function YahooFooter() {
  return (
    <footer className={ classes.yahooFooter } data-testid="yahooFooter">
      <div className={ classes.footerContent }>
        <CopyrightCashParking />
        <PrivacyPolicy />
      </div>
    </footer>
  );
}
